module.exports = __webpack_public_path__ + "img/map-icon-merch.8e0e25ee.png";